import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function Settings() {
  const [settings, setSettings] = useState({});
  const [loading, setLoading]   = useState(false);

  useEffect(() => { fetchSettings(); }, []);

  const fetchSettings = async () => {
    const res = await api.get('/settings');
    setSettings(res.data);
  };

  const set = k => e => setSettings(s => ({...s, [k]: e.target.value}));

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.put('/settings', settings);
      toast.success('Settings saved successfully');
    } catch (err) {
      toast.error('Failed to save settings');
    } finally { setLoading(false); }
  };

  return (
    <div>
      <h1 className="page-title">Company Settings</h1>
      <form onSubmit={handleSave}>
        <div className="card mb-16">
          <div className="card-title">🏢 Company</div>
          <div className="form-group">
            <label className="form-label">Company Name</label>
            <input className="form-control" value={settings.company_name||''} onChange={set('company_name')}/>
          </div>
        </div>

        <div className="card mb-16">
          <div className="card-title">🌐 Office IP Restriction</div>
          <p className="text-muted mb-16" style={{fontSize:13}}>
            Employees can only check in from this IP address. Leave as 0.0.0.0 to allow from anywhere (not recommended).
            To find your office IP, visit <strong>whatismyip.com</strong> from the office network.
          </p>
          <div className="form-group">
            <label className="form-label">Office Public IP Address</label>
            <input className="form-control" value={settings.office_ip||''} onChange={set('office_ip')}
              placeholder="e.g. 203.192.xx.xx"/>
          </div>
        </div>

        <div className="card mb-16">
          <div className="card-title">⏰ Work Hours</div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Work Start Time</label>
              <input className="form-control" type="time" value={settings.work_start||'09:00'} onChange={set('work_start')}/>
            </div>
            <div className="form-group">
              <label className="form-label">Work End Time</label>
              <input className="form-control" type="time" value={settings.work_end||'18:00'} onChange={set('work_end')}/>
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Late Arrival Threshold</label>
            <input className="form-control" type="time" value={settings.late_threshold||'09:30'} onChange={set('late_threshold')}/>
            <small className="text-muted" style={{fontSize:11}}>Employees not checked in by this time are marked as late</small>
          </div>
        </div>

        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? 'Saving...' : 'Save Settings'}
        </button>
      </form>
    </div>
  );
}
